module.exports = __webpack_public_path__ + "img/dashboard-stock.c0d4e19d.png";